import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ITraining,
  ITrainingResponse,
  ITrainingState,
} from "../@types/training";

const initialState: ITrainingState = {
  trainings: [],
  training: null,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  loadingTrainingId: null,
};

export const training = createSlice({
  name: "training",
  initialState,
  reducers: {
    setTrainings: (state, action: PayloadAction<ITrainingResponse>) => {
      state.trainings = action.payload.data.data;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
    },
    setTraining: (state, action: PayloadAction<ITraining>) => {
      state.training = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLoadingId: (state, action: PayloadAction<string | null>) => {
      state.loadingTrainingId = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTrainings, setTraining, setLoading, setLoadingId } =
  training.actions;

export default training.reducer;
